<template>
  <b-modal
    id="vipAccessForm"
    class="vellos-form"
    :title="modalTitle"
    centered
    hide-footer
  >
    <template v-slot:modal-title>
      {{ modalTitle }}
      <b-link
        href="https://vello.vip/vip-faqs/"
        target="_blank"
        title="Learn more about VIP Subscription"
      >
        <b-img
          src="~@/assets/img/info.svg"
          class="d-inline-block mt-n1"
          height="25px"
        />
      </b-link>
    </template>
    <b-overlay
      :show="loading"
      rounded="sm"
      variant="transparent"
      opacity="1"
      blur="1px"
    >
      <b-container v-if="profile">
        <b-row>
          <b-col class="text-center mt-n4">
            <small v-if="package_settings">{{
              package_settings.vip_description
            }}</small>

            <b-row v-if="showCard && showDefaultCard">
              <b-col>
                <add-card
                  type="vip"
                  @cancel="showCard = false"
                  @complete="
                    ;(showCard = false),
                      (showDefaultCard = false),
                      proceedVIPSubscribe()
                  "
                />
              </b-col>
            </b-row>

            <b-row v-else>
              <b-col>
                <b-button-group class="mt-4 vip-option" v-if="isYearlyEnabled">
                  <b-button
                    ref="monthlyBtn"
                    variant="black"
                    :class="isMonthly ? `active` : ``"
                    @click="selected_type = 'vip'"
                  >
                    <div class="mb-n2">Monthly</div>
                    <small>subscription</small>
                    <h4 class="mt-2">
                      <small>
                        <small>{{ packages.vip.symbol }}</small>
                      </small>
                      <span>{{ toFixedNum(packages.vip.price) }}</span>
                    </h4>
                  </b-button>
                  <b-button
                    ref="yearlyBtn"
                    variant="black"
                    :class="!isMonthly ? `active` : ``"
                    @click="selected_type = 'vip_yearly'"
                  >
                    <div class="discount-label">
                      {{ packages.vip_yearly.discount }}% off
                    </div>
                    <div class="mb-n2">Yearly</div>
                    <small>subscription</small>
                    <h4 class="mt-2">
                      <small>
                        <small>{{ packages.vip_yearly.symbol }}</small>
                      </small>
                      <span>{{ toFixedNum(packages.vip_yearly.price) }}</span>
                    </h4>
                  </b-button>
                </b-button-group>

                <b-form-group>
                  <b-button
                    variant="gold"
                    size="sm"
                    class="radius-15 py-3 px-4 mt-4 light w-100"
                    @click="proceedVIPSubscribe"
                  >
                    {{ buttonLabel }}
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AddCard from './AddCard'
export default {
  name: 'VipAccessModal',
  components: { AddCard },

  data() {
    return {
      selected_type: 'vip',
      loading: false,
      showCard: false,
      showDefaultCard: true,
    }
  },

  computed: {
    ...mapState({
      card: (state) => state.auth.card,
      profile: (state) => state.influencer.profile,
      packages: (state) => state.influencer.packages,
      package_settings: (state) => state.influencer.package_settings,
    }),

    modalTitle: function () {
      let name = `@` + this.profile.influencer.username

      if (this.profile.influencer.first_name) {
        name = this.profile.influencer.first_name
      }

      return name + `'s VIP Access`
    },

    isMonthly() {
      return this.selected_type === 'vip'
    },

    buttonLabel() {
      if (this.packages) {
        if (this.isMonthly) {
          return `Subscribe (${this.packages.vip.symbol}${this.toFixedNum(
            this.packages.vip.price
          )}/month)`
        }

        return `Subscribe (${this.packages.vip_yearly.symbol}${this.toFixedNum(
          this.packages.vip_yearly.price
        )}/year)`
      }

      return `Subscribe`
    },

    isYearlyEnabled() {
      return this.packages && this.packages.vip_yearly.is_active
    },
  },

  methods: {
    ...mapActions({
      getProfile: 'influencer/getProfile',
    }),

    toFixedNum(num) {
      return num.toFixed(2)
    },

    async proceedVIPSubscribe() {
      if (!this.card || this.showDefaultCard) {
        this.showCard = true
        return
      }

      this.showDefaultCard = true
      this.showCard = false
      this.loading = true

      let influencerUID = this.profile.influencer.influencer_uid
      let params = {
        type: this.selected_type,
      }

      await this.$api
        .post(`influencer/${influencerUID}/subscribe/vip`, params)
        .then(({ data }) => {
          this.loading = false
          this.showToast('success', data.message)

          // reload profile
          this.getProfile(influencerUID)
        })
        .catch((error) => {
          this.loading = false
          this.showToast('danger', error.response.data.message)
        })

      this.$root.$emit('bv::hide::modal', 'vipAccessForm')
    },

    showToast(type, message) {
      this.$bvToast.toast(message, {
        variant: type,
        noCloseButton: true,
        toaster: 'b-toaster-bottom-right',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.vip-option {
  background: black !important;
  border-radius: 10px;
  width: 100%;

  .btn {
    background: black !important;
    border-radius: 10px !important;
    color: #303034;
    padding: 8px;

    &.btn-black,
    &.btn-black:focus {
      background-color: #000;
      border-color: #000;

      &.active {
        border: 1px solid darkgoldenrod;
        color: white;
        z-index: 10;
      }
    }
  }

  .discount-label {
    top: -20px;
    width: 70px;
    padding: 3px;
    font-size: 10px;
    font-weight: 700;
    background: white;
    position: relative;
    border-radius: 5px;
    color: darkgoldenrod;
    font-family: monospace;
    margin: auto auto -15px;
  }
}
</style>
